import {Component, OnInit} from '@angular/core';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {Observable, of} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {routerTransition} from '@app/router.animations';
import {CommonModule, DatePipe, NgOptimizedImage} from '@angular/common'
import {ToastrService} from 'ngx-toastr';
import {ConsultingService, LoaderService} from '@app/shared/services';
import {OrderService} from '@app/shared/services/order.service';
import {SelectDropDownModule} from 'ngx-select-dropdown';
import {FormsModule} from '@angular/forms';
import {NgbHighlight, NgbTypeahead} from '@ng-bootstrap/ng-bootstrap';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import moment from 'moment';
import {UtilsInjectable} from '@app/shared';
import {environment} from '@env/environment';

@Component({
  selector: 'app-new-purchase-order',
  templateUrl: './new-purchase-order.component.html',
  styleUrls: ['./new-purchase-order.component.scss'],
  animations: [routerTransition()],
  imports: [
    CommonModule,
    FormsModule,
    SelectDropDownModule,
    NgbTypeahead,
    PageHeaderComponent,
    NgbHighlight,
    NgOptimizedImage
  ],
  providers: [DatePipe]
})
export class NewPurchaseOrderComponent implements OnInit {
  public env = environment;
  user_rights: any;
  user_data: any;
  purchase_order_details: any[] = [];
  public purchase_order: any =
    {
      vendor_id: '',
      order_id: '',
      order_no: '',
      order_date: new Date(),
      reference_date: '',
      payment_reference: '',
      total_amount: '',
      ship_to: '',
      medicine_data: [],
      medicine: [""],
      quantity: [""],
      uom: [""],
      uom_name: [""],
      amount: [""],
      unitprice: [""],
      last_pur_date: [""],
      last_pur_vendor: [""],
      user_id: '',
      medicine_price: ["0"],
      total: [""]
    }
  searching = false;
  searchFailed = false;
  date: any;
  unit: any;
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  index: any;
  status: any;
  vendor: any;
  vendor_options: any;
  orderd: any;
  public item_list: any[] = [];
  vendor_data: any;
  save_status: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "");
  ordered: any;

  constructor(private loaderService: LoaderService,
              public orderService: OrderService,
              public consultingService: ConsultingService,
              private toastr: ToastrService,
              private router: Router,
              private route: ActivatedRoute,
              protected utils: UtilsInjectable
  ) {

  }

  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "");
    this.user_data = JSON.parse(localStorage.getItem('user') || "");
    this.purchase_order.user_id = this.user_data.user_id;
    this.purchase_order.ship_to = this.institution.INSTITUTION_NAME + '\n ' + this.institution.INSTITUTION_ADDRESS + '\n ' + this.institution.INSTITUTION_CITY + ' \n ' + this.institution.INSTITUTION_COUNTRY_NAME;
    this.purchase_order_details = [{}]
    this.getDropdowns();
    this.route.params.subscribe(params => {
      this.purchase_order.order_id = Number.parseInt(params['order_id']);
      this.getDropdowns();
      const id = +(this.route.snapshot.paramMap.get('id') ?? "");
      if (id != null && id != 0) {
        this.purchase_order.order_id = '';
        this.getPurchaseOrderDetails(id);
      } else {
        this.purchase_order_details = [{...this.purchase_order}]
        this.getDropdowns();
      }
    });
  }

  public getPurchaseOrderDetails(id: any) {
    this.getDropdowns();
    const postData = {
      order_id: id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.getOrder(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.ordered = result['data'];
        this.vendor_data = {
          VENDOR_ID: this.ordered.VENDOR_ID,
          VENDOR_NAME: this.ordered.VENDOR_NAME,
          VENDOR_CODE: this.ordered.VENDOR_CODE,
          VENDOR_ADDRESS: this.ordered.VENDOR_ADDRESS,
          VENDOR_PHONE: this.ordered.VENDOR_PHONE
        };
        this.purchase_order.order_id = this.ordered.PURCHASE_ORDER_ID;
        this.purchase_order.vendor_id = this.ordered.VENDOR_ID;
        this.purchase_order.order_no = this.ordered.PURCHASE_ORDER_NUMBER;
        this.purchase_order.order_date = this.ordered.PURCHASE_ORDER_DATE;
        this.purchase_order.reference_date = this.ordered.REFERENCE_DATE;
        if (this.ordered.SHIP_TO) {
          this.purchase_order.ship_to = this.ordered.SHIP_TO;
        }
        this.purchase_order.payment_reference = this.ordered.PAYMENT_REFERENCE;
        this.purchase_order.total_amount = this.ordered.GRAND_TOTAL;

        let i = 0;
        const orders = [];
        for (const val of result['data'].PURCHASE_ORDER) {
          const temp = {
            'MEDICINE_ID': val.MEDICINE_ID,
            'TRADE_NAME': val.TRADE_NAME,
          };
          orders.push(i);
          this.purchase_order.medicine_data[i] = temp;
          this.purchase_order.medicine[i] = val.MEDICINE_ID;
          this.purchase_order.quantity[i] = val.QUANTITY;
          this.purchase_order.uom[i] = val.UNIT_DESC;
          this.purchase_order.uom_name[i] = val.UNIT_DESC;
          this.purchase_order.medicine_price[i] = val.UNIT_PRICE;
          this.purchase_order.last_pur_date[i] = val.LAST_DATE;
          this.purchase_order.last_pur_vendor[i] = val.SUPPLIER_NAME;
          this.purchase_order.unitprice[i] = val.LAST_PURCHASE_UNIT_PRICE;
          this.purchase_order.total[i] = val.TOTAL_AMOUNT;
          i = i + 1;
        }
        this.purchase_order_details = orders
        this.loaderService.display(false);
      } else {
        this.purchase_order = {
          vendor_id: '',
          order_id: '',
          order_no: '',
          reference_date: '',
          order_date: new Date(),
          payment_reference: '',
          total_amount: '',
          ship_to: '',
          medicine_data: [],
          medicine: [""],
          quantity: [""],
          uom: [""],
          uom_name: [""],
          amount: [""],
          unitprice: [""],
          last_pur_date: [""],
          last_pur_vendor: [""],
          user_id: '',
          medicine_price: ["0"],
          total: [""]
        }
        this.loaderService.display(false);
      }
    });
  }

  public getToday(): string {
    return new Date().toISOString().split('T')[0]
  }

  getVendor(data: any) {
    if (data['value'])
      this.purchase_order.vendor_id = data['value'].VENDOR_ID;
  }

  public set_item_medicine($event: any, i: any) {
    const item = $event.item;
    this.purchase_order.medicine[i] = item.MEDICINE_ID;
    this.purchase_order.uom[i] = item.UNIT;
    this.purchase_order.uom_name[i] = item.UNIT_DESC;
    if (item.LAST_DATE != null) {
      this.purchase_order.last_pur_date[i] = moment.utc(item.LAST_DATE).format("DD/MM/YYYY");
    }
    this.purchase_order.last_pur_vendor[i] = item.SUPPLIER_NAME;
    this.purchase_order.unitprice[i] = item.LAST_RATE;
    this.getMedicine(item, i);
  }

  public purached_order_items(id: any) {
    const postData = {
      order_id: id
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.getOrder(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.orderd = result['data'];
        this.item_list = result['data'].PURCHASE_ORDER;
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }
    });
  }

  public clear_purchase() {
    this.purchase_order_details = [];
    this.purchase_order = {
      order_id: '',
      vendor_id: '',
      order_no: '',
      reference_date: '',
      order_date: new Date(),
      payment_reference: '',
      total_amount: '',
      ship_to: this.institution.INSTITUTION_NAME + ',' + this.institution.INSTITUTION_ADDRESS + ',' + this.institution.INSTITUTION_CITY + ' , ' + this.institution.INSTITUTION_COUNTRY_NAME,
      medicine_data: [],
      medicine: [""],
      quantity: [""],
      uom: [""],
      uom_name: [""],
      amount: [""],
      unitprice: [""],
      last_pur_date: [""],
      last_pur_vendor: [""],
      user_id: '',
      medicine_price: ["0"],
      total: [""]
    }
    this.vendor_data = ""
    this.getDropdowns();
    this.addrow(-1);
  }

  public savePurchaseOrder(): any {

    if (this.purchase_order.vendor_id == '') {
      this.toastr.error('Please select a Supplier !');
      return false;
    }
    if (this.purchase_order.order_date == '') {
      this.toastr.error('Please select Order date !');
      return false;
    }
    if(this.purchase_order.medicine_data.length == 0){
      this.toastr.error('Please add at least one particular!');
      return false;
    }

    let rel = 1;
    this.purchase_order.quantity.forEach((item: any, index: any): any => {
      if (this.purchase_order.medicine[index] > 0) {
        if (this.purchase_order.quantity[index] == "") {
          this.toastr.error('Please enter quantity');
          rel = 0;
          return false;
        }
      }
    });
    if (rel == 0) {
      return false
    }
    this.loaderService.display(true);
    this.orderService.savePurchaseOrder(this.purchase_order).subscribe((result: any) => {
      window.scrollTo(0, 0)
      if (result["status"] == "Success") {
        this.save_status = result["status"];
        this.purached_order_items(result.data_id);
        this.loaderService.display(false);
        this.toastr.success(result.msg);
        this.purchase_order.ship_to = this.institution.INSTITUTION_NAME + ',' + this.institution.INSTITUTION_ADDRESS + ',' + this.institution.INSTITUTION_CITY + ' , ' + this.institution.INSTITUTION_COUNTRY_NAME;
        this.clear_purchase();
      } else {
        this.toastr.error(result.msg);
        this.loaderService.display(false);
      }
    })
  }

  public getMedicine(data: any, i: any) {
    const postData = {
      medicine_id: data.MEDICINE_ID
    };
    this.loaderService.display(true);
    this.loaderService.display(true);
    this.consultingService.getMedicine(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        const medilist_data = result['data'];
        this.purchase_order.medicine[i] = medilist_data.MEDICINE_ID;
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
      }

    });
  }

  public totalprice() {
    let sum = 0;
    let total = 0;

    this.purchase_order.quantity.forEach((item: any, index: any) => {
      const qty = parseInt(this.purchase_order.quantity[index]);
      const unit_price = parseFloat(this.purchase_order.medicine_price[index]);
      if (qty >= 0 && unit_price >= 0) {
        if (!isNaN(qty)) {
          sum = qty * unit_price;
        } else {
          sum = 0;
        }
        this.purchase_order.total[index] = sum.toFixed(2);
      } else {
        this.purchase_order.total[index] = sum.toFixed(2);
      }

      const amount = parseFloat(this.purchase_order.total[index]);
      if (!isNaN(amount)) {
        total = total + amount
      }
    });
    this.purchase_order.total_amount = Math.round(total);

  }

  public addrow(index: any) {
    this.purchase_order_details[index + 1] = '';
    this.purchase_order.medicine_data[index + 1] = '';
    this.purchase_order.quantity[index + 1] = '';
    this.purchase_order.uom_name[index + 1] = '';
    this.purchase_order.unitprice[index + 1] = '';
    this.purchase_order.total[index + 1] = '';
  }

  public deleterow(index: any) {
    this.purchase_order_details.splice(index, 1);
    this.purchase_order.medicine_data.splice(index, 1);
    this.purchase_order.medicine.splice(index, 1);
    this.purchase_order.quantity.splice(index, 1);
    this.purchase_order.uom_name.splice(index, 1);
    this.purchase_order.unitprice.splice(index, 1);
    this.purchase_order.medicine_price.splice(index, 1);
    this.purchase_order.total.splice(index, 1);
    this.totalprice();
  }

  public getDropdowns() {
    const postData = {
      vendor_id: ''
    }
    this.loaderService.display(true);
    this.orderService.listVendor(postData).subscribe((result: any) => {
      this.loaderService.display(false);
      if (result['status'] == 'Success') {
        this.vendor = result['data'];
        this.vendor_options = this.vendor;
        for (let index = 0; index < this.vendor_options.length; index++) {
          if (this.vendor_options[index].VENDOR_ID == this.purchase_order.vendor_id) {
            this.vendor_data = this.vendor_options[index];
          }
        }
      }
    });

  }

  medicine_search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(500),
      distinctUntilChanged(),
      tap(() => this.searching = true),
      switchMap(term =>
        this.orderService.medicine_search(term).pipe(
          map((response: any) => {
            this.searchFailed = false
            if (response.status == 'Success') {
              return response.data;
            } else {
              return [];
            }
          }),
          catchError(() => {
            this.searchFailed = true;
            return of([]);
          })
        )
      ),
      tap(() => this.searching = false)
    )
  formatter = (x: any): any => x.TRADE_NAME;

  allowNumberOnly(event: any) {
    let value = event.target.value;
    value = value.replace(/[^0-9.]/g, '');

    const parts = value.split('.');
    if (parts.length > 1) {
      value = parts[0]+'.'
      value = value+parts.splice(1).join('')
    }

    event.target.value = value;
  }

}
